<template>
    <Modal v-model="show"
        :width="80"
        :footer-hide="true"
        title="现售入库单详情"
        class-name="vertical-center-modal"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form ref="warehouseEntryFrom"
                    label-position="top"
                    class="small-form">
                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="单号">
                            <Input :value="warehouseEntryFrom.record.warehouseEntryRecordBillCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="批次">
                            <Input :value="warehouseEntryFrom.record.warehouseEntryRecordBatchCode"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="项目">
                            <Input :value="warehouseEntryFrom.record.warehouseEntryRecordProject"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="电话">
                            <Input :value="warehouseEntryFrom.record.warehouseEntryRecordContactNumber"></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单时间">
                            <Input :value="formatWarehouseEntryRecordCreateAt"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单人">
                            <Input :value="warehouseEntryFrom.ownerName"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <Card class="thin-card-title"
                    :padding="0"
                    :bordered="false"
                    :dis-hover="true">
                    <p slot="title">入库产品</p>
                    <Table :columns="entryTable.tableColumns"
                        :data="warehouseEntryFrom.details"
                        size="small"
                        :border="true"
                        :stripe="true" />
                </Card>
                </Col>
            </Row>
        </Card>

    </Modal>
</template>

<script>
import { formatDateString } from '@/libs/logic';
import { number2ThousandsFormat } from '@/components/number-input/display-format';

import { getCurSaleWarehouseEntryDetail } from '@/api/modules/warehouse-management/warehouseEntry';

export default {
    name: 'WarehouseEntryDetail',
    data() {
        return {
            show: false,
            innerSpin: false,
            entryUuid: '',
            warehouseEntryFrom: {
                ownerName: '',
                record: {
                    userPersonName: '',
                    warehouseEntryRecordUuid: '',
                    warehouseEntryRecordProject: '',
                    warehouseEntryRecordContactNumber: '',
                    warehouseEntryRecordBillCode: '',
                    warehouseEntryRecordStatus: '',
                    warehouseEntryRecordCreateAt: '',
                    warehouseEntryRecordBatchCode: ''
                },
                details: []
            },
            entryTable: {
                tableColumns: [
                    { title: '产品编号', key: 'warehouseEntryDetailProductCode', align: 'center' },
                    { title: '名称', key: 'warehouseEntryDetailProductName', align: 'center' },
                    { title: '入库数量', key: 'warehouseEntryDetailAmount', align: 'center' },
                    {
                        title: '现售价',
                        key: 'warehouseEntryDetailPrice',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.warehouseEntryDetailPrice, 4, '￥'))
                            ]);
                        }
                    },
                    {
                        title: '金额',
                        key: 'warehouseEntryDetailMoney',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.warehouseEntryDetailMoney, 4, '￥'))
                            ]);
                        }
                    },
                    { title: '备注', key: 'warehouseEntryDetailRemark', align: 'center' }
                ]
            }
        };
    },
    computed: {
        formatWarehouseEntryRecordCreateAt() {
            if (this.warehouseEntryFrom.record.warehouseEntryRecordCreateAt === '') {
                return '';
            }
            return formatDateString(this.warehouseEntryFrom.record.warehouseEntryRecordCreateAt);
        }
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(entryUuid) {
            this.entryUuid = entryUuid;
            this.show = true;
        },
        init() {
            if (this.entryUuid) {
                this.innerSpin = true;
                getCurSaleWarehouseEntryDetail(this.entryUuid).then(detail => {
                    this.innerSpin = false;

                    if (detail.code === 0) {
                        const rsp = detail.data;
                        this.warehouseEntryFrom.ownerName = rsp.ownerName;
                        this.warehouseEntryFrom.record = Object.assign(this.warehouseEntryFrom.record, rsp.record);
                        this.warehouseEntryFrom.details = rsp.details;

                        let totalAmount = 0;
                        this.warehouseEntryFrom.details.forEach(e => {
                            totalAmount += e.warehouseEntryDetailAmount;
                        });
                        this.warehouseEntryFrom.details.push({
                            warehouseEntryDetailAmount: totalAmount,
                            warehouseEntryDetailProductName: '合计',
                            warehouseEntryDetailPrice: null,
                            warehouseEntryDetailMoney: null
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        }
    }
};
</script>

<style scoped>
</style>
